import type { Condition, Provider } from '@repo/api-gw-sdk';
import { useDAL } from '@/contexts/useDAL';
import type { ConditionPanelHost } from '@/types/advanceFilter';
import type { TagFilterMode } from './tagKeyValueUtils';
import type { FilterProps } from '../filters';
export interface TagsConditionProps extends FilterProps {
  supportedProviders?: Provider[];
  initialFilterMode: TagFilterMode;
  panelHost?: ConditionPanelHost;
  /** Runs whenever the popover closes, hosted or not — for the wrapper's own cleanup. */
  onPanelClose?: () => void;
  dataSource?: 'tags' | 'sourceAccountTags';
}
export interface TagsDataResult {
  data: {
    tags?: {
      key: string;
      value?: string | null;
    }[];
  } | undefined;
  isLoading: boolean;
}
export function useResourceTagsData(filter?: Condition): TagsDataResult {
  const dal = useDAL();
  return dal.inventory.tags.useList(filter);
}
export function useSourceAccountTagsData(filter?: Condition): TagsDataResult {
  const dal = useDAL();
  return dal.inventory.sourceAccountTags.useList(filter);
}